export default "__VITE_ASSET__a3c10184__"